import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


function Infra() {
   const location = useLocation();
    
      // Scroll to the section if specified in the URL state
      useEffect(() => {
        if (location.state?.scrollTo) {
          const element = document.getElementById(location.state.scrollTo);
          if (element) {
            // Use smooth scrolling to the section
            element.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, [location]);
    return (
        <div>
                <div  className='ibdp-hero-sec'>
            <img src='newimg/Screenshot_24.webp'/>
    
          </div>
          <div className="newsletter-sec">
          <div id='SanskarInfrastructure' className='photo-sec'>
           
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/infa.webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/infa.webp'></img>
              </Link>
            </div>
           
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/1 (6).webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/1 (6).webp'></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/infa4.webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/infa4.webp'></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/infa5.webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/infa5.webp'></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/infa6.webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/infa6.webp'></img>
              </Link>
            </div>
           
            
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/infa2.webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/infa2.webp'></img>
              </Link>
            </div>
       
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/1 (19).webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/1 (19).webp'></img>
              </Link>
            </div>
     
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/1 (50).webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/1 (50).webp'></img>
              </Link>
            </div>
           
            <div className='photo-box'>
            <Link to="../newimg/Manual/DSC05445.webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/Manual/DSC05445.webp'></img>
              </Link>
            </div>
            
            <div className='photo-box'>
            <Link to="../newimg/Manual/DSC05482.webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/Manual/DSC05482.webp'></img>
              </Link>
            </div>
           
            <div className='photo-box'>
            <Link to="../newimg/Manual/DSC05448 (1).webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/Manual/DSC05448 (1).webp'></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to="../newimg/Manual/DSC05488.webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/Manual/DSC05488.webp'></img>
              </Link>
            </div>
      
            <div className='photo-box'>
            <Link to="../newimg/Manual/DSC05600.webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/Manual/DSC05600.webp'></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to="../newimg/Manual/DSC05554.webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/Manual/DSC05554.webp'></img>
              </Link>
            </div>
      
      
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/infra-game.webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/infra-game.webp'></img>
              </Link>
            </div>
            
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/1 (13).webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/1 (13).webp'></img>
              </Link>
            </div>
            
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/1 (15).webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/1 (15).webp'></img>
              </Link>
            </div>
           
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/1 (47).webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/1 (47).webp'></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/1 (21).webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/1 (21).webp'></img>
              </Link>
            </div>
            
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/1 (25).webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/1 (25).webp'></img>
              </Link>
            </div>
      
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/1 (29).webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/1 (29).webp'></img>
              </Link>
            </div>
           
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/1 (37).webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/1 (37).webp'></img>
              </Link>
            </div>
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/1 (65).webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/1 (65).webp'></img>
              </Link>
            </div>
        
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/1 (70).webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/1 (70).webp'></img>
              </Link>
            </div>
          
            <div className='photo-box'>
            <Link to="../newimg/School Latest PIcs/1 (86).webp"
                target="_blank"
                rel="noopener noreferrer">
               <img src='../newimg/School Latest PIcs/1 (86).webp'></img>
              </Link>
            </div>
      
      
           
           
           
         

           

    
        </div>
        </div>
        </div>
      )
    }

    export default Infra;
